/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Scrollbar, Lazy, FreeMode } from 'swiper';



$(document).ready(function(){	  

	  const swiper = new Swiper('.galleryswiper', {

		modules: [Navigation, Pagination, Scrollbar, FreeMode],

		spaceBetween: 15,
		slidesPerView:"auto",
		freeMode: true,
		grabCursor:true,
		mousewheel: true,		
		preloadImages: false,
		breakpoints: {
		  1024: {
			slidesPerView: "auto",
		  }
		},

        scrollbar: {
          el: ".galleryswiper .swiper-scrollbar",
		  draggable: true,
        },

		pagination: {
		  el: '.galleryswiper .swiper-pagination',
		},	  

		navigation: {
		  nextEl: '.galleryswiper .swiper-button-next',
		  prevEl: '.galleryswiper .swiper-button-prev',
		},

	  });

		
});










